import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import './chapter.css'
import Navbar from './components/Navbar';
import Footer from './Footer';

function Chapter() {
    let navigate = useNavigate()
    let param = useParams();
    const [chapter,setChapter] = useState({})
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(()=>{
        fetch('https://bhagavad-gita3.p.rapidapi.com/v2/chapters/' + param.id + '/',{
            "method": "GET",
            "headers": {
              "x-rapidapi-host": "bhagavad-gita3.p.rapidapi.com",
              "x-rapidapi-key": '4034969b2cmshf9e4ab0b6a68552p1e99cajsn6474fa44b7c4'
            }
        })
        .then((res) =>{
            return res.json()
        }).then((res) =>{
            setChapter(res);
        })
        .catch(error => console.log(error))
        .finally(() => setIsLoading(false))
    },[param.id]);
    
    if (isLoading) {
        return <div className="d-flex justify-content-center center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>;
    }

  return (
    <>
        <Navbar/>
        <div name='chaptes' className='card-container'>
        <div className="card mb-3">
            <img src='https://www.krishnatemple.com/wp-content/uploads/2022/04/Festival_Gita_Jayanti.jpg' class="card-img-top" alt="..."/>
            <div className="card-body">

                <h3 class="card-name">{chapter.name}</h3>
                <h4>{chapter.name_meaning}</h4>

                <p className='parag'>{chapter.slug}</p>
                <hr class="solid"></hr>

                <h5 className='summary-head'>Summary Hindi:</h5>
                <p className='parag-hindi'>{chapter.chapter_summary_hindi}</p>

                <h5 className='summary-head'>Summary English:</h5>
                <p className='parag'>{chapter.chapter_summary}</p>

                <h5 className='summary-head'>Verses:</h5>
                <div className='verse-line'></div>

                <h2>{chapter.verses_count}</h2>
                <div className='btn-container'>

                <Link to={'/chapter/' + chapter.id + '/verses'} className='link'>
                <button className='button'>
                    <i class="fa-solid fa-arrow-right"></i><span>Read Now</span>
                </button>
                </Link>

                <button className='button' onClick={() => navigate(-1)}>
                    <i class="fa-solid fa-arrow-left"></i><span>Back</span>
                </button>

                </div>
            </div>
        </div>
        </div>
        <Footer/>
    </>
  )
}

export default Chapter